import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';

export interface AppState {
	focusModeEnabled: boolean;
	appToolbarHeight: number;
	appSlideWidthPx: number;
	lastInteraction: number;
	showFocusMode: boolean;
	appChatWidthPx: number;
	sideBarOpened: boolean;
	appChatUserId: string;
	redirecting: boolean;
	chatOpened: boolean;
	appSidebarSelectedUserId: string;
	isFirstModuleDialogOpen: boolean;
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'ui-app' })
export class AppStore extends Store<AppState> {
	constructor() {
		super({
			chatOpened: false,
			showFocusMode: true,
			appChatWidthPx: 350,
			appSlideWidthPx: 300,
			appToolbarHeight: 45,
			sideBarOpened: false,
			isFirstModuleDialogOpen: false,
		});
	}
}
